
import { 
  WiDaySunny, 
  WiNightClear, 
  WiCloudy, 
  WiDayCloudy, 
  WiNightAltCloudy, 
  WiRain, 
  WiSnow, 
  WiFog, 
  WiThunderstorm, 
  WiShowers, 
  WiDayShowers, 
  WiNightAltShowers,
  WiDayRain,
  WiNightAltRain,
  WiDaySnow,
  WiNightAltSnow,
  WiDayFog,
  WiNightFog
} from 'react-icons/wi';

if (!process.env.REACT_APP_WEATHER_API_URL) {
  console.warn('REACT_APP_WEATHER_API_URL environment variable is not set');
}

export const WEATHER_CONFIG = {
  API_BASE_URL: process.env.REACT_APP_WEATHER_API_URL,
  
  DEFAULT_COORDINATES: {
    lat: 47.4979,  
    lon: 19.0402   
  },
  
  ENDPOINTS: {
    CURRENT_WEATHER: '/weather/current',
    WEEKLY_FORECAST: '/weather/extended',
    WEATHER_ALERTS: '/alerts/current'
  },
  
  REQUEST_TIMEOUT: 10000,
  
  RETRY: {
    MAX_ATTEMPTS: 3,
    DELAY: 1000
  },
  
  ICON_MAPPING: {
    sunny: WiDaySunny,
    cloudy: WiCloudy,
    rainy: WiRain,
    snowy: WiSnow,
    foggy: WiFog,
    partly_cloudy: WiDayCloudy,
    '01d': WiDaySunny, 
    '01n': WiNightClear, 
    '02d': WiDayCloudy, 
    '02n': WiNightAltCloudy, 
    '03d': WiCloudy, 
    '03n': WiCloudy, 
    '04d': WiCloudy, 
    '04n': WiCloudy, 
    '09d': WiShowers, 
    '09n': WiShowers, 
    '10d': WiDayShowers, 
    '10n': WiNightAltShowers, 
    '11d': WiThunderstorm, 
    '11n': WiThunderstorm, 
    '13d': WiDaySnow, 
    '13n': WiNightAltSnow, 
    '50d': WiFog, 
    '50n': WiFog, 
    default: WiDayCloudy
  },
  
  HUNGARIAN_DESCRIPTIONS: {
    sunny: 'Napos',
    cloudy: 'Felhős',
    rainy: 'Esős',
    snowy: 'Havas',
    foggy: 'Ködös',
    partly_cloudy: 'Részben felhős',
    overcast: 'Borult',
    'moderate rain': 'Mérsékelt eső',
    'moderate drizzle': 'Mérsékelt szitálás',
    'light drizzle': 'Enyhe szitálás',
    'dense drizzle': 'Sűrű eső',
    'mainly clear': 'Túlnyomóan napos',
    'partly cloudy': 'Részben felhős',
    'slight rain': 'Enyhe eső',
    'heavy rain': 'Sűrű eső',
    'light snow': 'Enyhe hó',
    'heavy snow': 'Sűrű hó',
    'light rain': 'Enyhe eső',
    'clear sky': 'Tiszta égbolt',
    'few clouds': 'Kevés felhő',
    'scattered clouds': 'Szétszórt felhők',
    'broken clouds': 'Töredezett felhőzet',
    'shower rain': 'Zápor',
    'rain': 'Eső',
    'thunderstorm': 'Zivatar',
    'snow': 'Hó',
    'mist': 'Köd',
    'fog': 'Köd',
    'haze': 'Ködös'
  },

  ALERT_TRANSLATIONS: {
    // Alert categories
    'yellow fog warning': 'Sárga köd figyelmeztetés',
    'yellow thunderstorm warning': 'Sárga zivatar figyelmeztetés',
    'yellow wind warning': 'Sárga szél figyelmeztetés',
    'yellow rain warning': 'Sárga eső figyelmeztetés',
    'yellow snow warning': 'Sárga hó figyelmeztetés',
    'orange fog warning': 'Narancs köd figyelmeztetés',
    'orange thunderstorm warning': 'Narancs zivatar figyelmeztetés',
    'orange wind warning': 'Narancs szél figyelmeztetés',
    'orange rain warning': 'Narancs eső figyelmeztetés',
    'red fog warning': 'Piros köd figyelmeztetés',
    'red thunderstorm warning': 'Piros zivatar figyelmeztetés',
    'red wind warning': 'Piros szél figyelmeztetés',

    // Titles
    'yellow fog warning for Hungary': 'Sárga köd figyelmeztetés Magyarországra',
    'yellow thunderstorm warning for Hungary': 'Sárga zivatar figyelmeztetés Magyarországra',
    'yellow wind warning for Hungary': 'Sárga szél figyelmeztetés Magyarországra',
    'yellow rain warning for Hungary': 'Sárga eső figyelmeztetés Magyarországra',

    // Descriptions
    'Dense fog can be expected for several hours.': 'Több órán át tartó sűrű köd várható.',
    'Attention! Thunderstorm (lightning) is expected, possibly accompanied by stormy gusts and hail.': 'Figyelem! Zivatar (villámlás) várható, esetleg viharos széllökésekkel és jégesővel.',
    'The windspeed can temporarily exceed 70 km/h.': 'A szélsebesség átmenetileg meghaladhatja a 70 km/h-t.',

    // Instructions
    'More widespread, locally dense fog affecting significant areas of the country but not persisting beyond 1 - 2 days. Some airports may close for short periods. Journeys through affected areas may take longer than usual. Take extra care when driving in affected areas.': 'Kiterjedtebb, helyenként sűrű köd érinti az ország jelentős területeit, de 1-2 napnál tovább nem tart. Egyes repülőterek rövid időre bezárhatnak. Az érintett területeken áthaladó utak a szokásosnál hosszabb időt vehetnek igénybe. Vezessen extra óvatosan az érintett területeken.',
    'Be especially careful in highly exposed places (mountains, forests, open areas).': 'Legyen különösen óvatos erősen kitett helyeken (hegyek, erdők, nyílt területek).',
    'Some branches or trees brought down. Localised travel disruption. Localised problems for high-sided vehicles on prone routes. Drive with care, especially on exposed routes. Be aware of possible debris being blown around.': 'Néhány ág vagy fa kidőlhet. Helyi közlekedési zavarok. Helyi problémák a magas oldalú járművek esetében az érzékeny útvonalakon. Vezessen óvatosan, különösen a nyílt utakon. Legyen tisztában azzal, hogy törmelék kavarghat a levegőben.',

    // Areas
    'Northern Great Plain': 'Észak-Alföld',
    'Southern Great Plain': 'Dél-Alföld',
    'Northern Hungary': 'Észak-Magyarország',
    'Central Hungary': 'Közép-Magyarország',
    'Central Transdanubia': 'Közép-Dunántúl',
    'Western Transdanubia': 'Nyugat-Dunántúl',
    'Southern Transdanubia': 'Dél-Dunántúl'
  }
};

export const getWeatherApiUrl = (endpoint, params = {}) => {
  const url = new URL(`${WEATHER_CONFIG.API_BASE_URL}${endpoint}`);
  
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      url.searchParams.append(key, value);
    }
  });
  
  return url.toString();
};

export const getWeatherIcon = (description, iconCode = null) => {
  if (iconCode && WEATHER_CONFIG.ICON_MAPPING[iconCode]) {
    return WEATHER_CONFIG.ICON_MAPPING[iconCode];
  }
  
  if (!description) return WEATHER_CONFIG.ICON_MAPPING.default;
  
  const desc = description.toLowerCase();

  if (WEATHER_CONFIG.HUNGARIAN_DESCRIPTIONS[desc]) {
    return WEATHER_CONFIG.HUNGARIAN_DESCRIPTIONS[desc];
  }
  
  if (desc.includes('napos') || desc.includes('sunny') || desc.includes('clear')) return WEATHER_CONFIG.ICON_MAPPING.sunny;
  if (desc.includes('felhős') || desc.includes('cloudy')) return WEATHER_CONFIG.ICON_MAPPING.cloudy;
  if (desc.includes('esős') || desc.includes('rainy') || desc.includes('rain')) return WEATHER_CONFIG.ICON_MAPPING.rainy;
  if (desc.includes('havas') || desc.includes('snowy') || desc.includes('snow')) return WEATHER_CONFIG.ICON_MAPPING.snowy;
  if (desc.includes('ködös') || desc.includes('foggy') || desc.includes('mist')) return WEATHER_CONFIG.ICON_MAPPING.foggy;
  if (desc.includes('részben') || desc.includes('partly')) return WEATHER_CONFIG.ICON_MAPPING.partly_cloudy;
  
  return WEATHER_CONFIG.ICON_MAPPING.default;
};

export const renderWeatherIcon = (description, iconCode = null, className = '', size = 24) => {
  const IconComponent = getWeatherIcon(description, iconCode);
  
  if (typeof IconComponent === 'string') {
    return <span className={className}>{IconComponent}</span>;
  }
  
  return <IconComponent className={className} size={size} />;
};

export const formatDay = (dateString) => {
  if (!dateString) return '---';
  
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '---';
    
    const days = ['Vasárnap', 'Hétfő', 'Kedd', 'Szerda', 'Csütörtök', 'Péntek', 'Szombat'];
    const dayName = days[date.getDay()];
    
    const dayOfMonth = date.getDate();
    return `${dayName} ${dayOfMonth}.`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return '---';
  }
};

export const getHungarianWeatherDescription = (description) => {
  if (!description) return '---';

  const desc = description.toLowerCase();

  if (WEATHER_CONFIG.HUNGARIAN_DESCRIPTIONS[desc]) {
    return WEATHER_CONFIG.HUNGARIAN_DESCRIPTIONS[desc];
  }

  if (desc.includes('overcast')) return 'Borult';
  if (desc.includes('moderate rain')) return 'Mérsékelt eső';
  if (desc.includes('moderate drizzle')) return 'Mérsékelt szitálás';
  if (desc.includes('light drizzle')) return 'Könnyű szitálás';
  if (desc.includes('dense drizzle')) return 'Sűrű szitálás';
  if (desc.includes('mainly clear')) return 'Főleg tiszta';
  if (desc.includes('clear sky')) return 'Tiszta égbolt';
  if (desc.includes('few clouds')) return 'Kevés felhő';
  if (desc.includes('scattered clouds')) return 'Szétszórt felhők';
  if (desc.includes('broken clouds')) return 'Törött felhők';
  if (desc.includes('shower rain')) return 'Zápor';
  if (desc.includes('thunderstorm')) return 'Zivatar';

  return description;
};

export const translateAlertText = (text) => {
  if (!text) return text;

  // Check for exact match first
  if (WEATHER_CONFIG.ALERT_TRANSLATIONS[text]) {
    return WEATHER_CONFIG.ALERT_TRANSLATIONS[text];
  }

  // Return original if no translation found
  return text;
};

export default WEATHER_CONFIG;
